import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import PackageCard from "@/components/PackageCard";

export default function PackagesPage() {
    const [packages, setPackages] = useState([]);
    const [filter, setFilter] = useState("all");
    const navigate = useNavigate();

    useEffect(() => {
        api.get("/packages").then((r) => setPackages(r.data));
    }, []);

    const filtered =
        filter === "all" ? packages : packages.filter((p) => p.category === filter);

    return (
        <div data-testid="packages-page" className="pt-32 lg:pt-40 pb-24">
            <header className="max-w-7xl mx-auto px-6 lg:px-10 mb-14">
                <span className="overline">Menu Packages</span>
                <h1 className="font-serif font-light text-5xl md:text-6xl lg:text-7xl text-forest-700 mt-5 leading-[1.05] max-w-3xl">
                    Eight ways to dine.
                    <br />
                    <em className="italic">One unforgettable evening.</em>
                </h1>
                <p className="text-forest-700/70 leading-relaxed mt-6 max-w-2xl">
                    From a relaxed family lasagna delivered to your villa, to a
                    four-course tasting plated by a private chef in your kitchen —
                    choose the experience that fits your gathering.
                </p>

                <div className="mt-10 flex flex-wrap gap-2" role="tablist">
                    {[
                        { key: "all", label: "All Menus" },
                        { key: "drop_off", label: "Drop-Off" },
                        { key: "in_villa", label: "On-Site Chef" },
                    ].map((t) => (
                        <button
                            key={t.key}
                            data-testid={`filter-${t.key}`}
                            onClick={() => setFilter(t.key)}
                            className={`px-5 py-2.5 rounded-sm border text-sm tracking-wide transition-colors ${
                                filter === t.key
                                    ? "bg-forest-700 text-sand-100 border-forest-700"
                                    : "bg-transparent border-palm-400/50 text-forest-700/80 hover:border-forest-700"
                            }`}
                        >
                            {t.label}
                        </button>
                    ))}
                </div>
            </header>

            <section className="max-w-7xl mx-auto px-6 lg:px-10">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {filtered.map((p, i) => (
                        <div key={p.id} onClick={() => navigate(`/packages/${p.id}`)} className="cursor-pointer">
                            <PackageCard pkg={p} index={i} />
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
}
